import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

import { BaseServices } from './../../kuba.services';
import { Department, VehicleList } from './../models/vehicle';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VehicleServices {
  constructor(private http: HttpClient) {}

  getAllVehicles() {
    return this.http
      .get(
        environment.BASE_URL + '/vehicle/vehicles/' + BaseServices.BusinessId
      ).pipe(rxjsmap((result: any) => result));
  }

  getVehiclesById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/vehicle/vehicle/' + id).pipe(rxjsmap((result: any) => result));
  }

  createVehicle(vehicle: VehicleList) {
    return this.http
      .post(environment.BASE_URL + '/vehicle/vehicle', vehicle).pipe(rxjsmap(result => result));
  }

  updateVehicle(vehicle: VehicleList) {
    return this.http
      .put(environment.BASE_URL + '/vehicle/vehicle', vehicle).pipe(rxjsmap(result => result));
  }

  deleteVehicle(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/vehicle/vehicle/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // update department in view
  updateDept(existingCategory: Department) {
    return this.http
      .put(
        environment.BASE_URL + '/department/' + existingCategory.Id,
        existingCategory
      ).pipe(rxjsmap(result => result));
  }

  // adding new department in view
  createDept(newCategory: Department) {
    return this.http
      .post(environment.BASE_URL + '/department/', JSON.stringify(newCategory)).pipe(rxjsmap(result => result));
  }

  deleteDepartment(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/departmentdelete/' + id).pipe(rxjsmap(result => result));
  }

  getVehicleFeatures(businessId: number) {
    let featureId: number;
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    featureId = workingModule.id;
    return this.http
      .get(environment.BASE_URL + '/business/' + businessId).pipe(rxjsmap((result: any) => {
        let feature = result.Features;
        let vehicleAdditionalFeature = _.find(JSON.parse(feature), {
          id: featureId,
          access: true
        });
        return vehicleAdditionalFeature;
      }));
  }

  getUserVehicles(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/vehicle/getuserVehicles/' + Id).pipe(rxjsmap((result: any) => result));
  }
}
